import { render, staticRenderFns } from "./adminheader.vue?vue&type=template&id=5f57ab28&scoped=true&"
import script from "./adminheader.vue?vue&type=script&lang=js&"
export * from "./adminheader.vue?vue&type=script&lang=js&"
import style0 from "./adminheader.vue?vue&type=style&index=0&id=5f57ab28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57ab28",
  null
  
)

export default component.exports